import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SwWrapperComponent } from './pages/sw-wrapper/sw-wrapper.component';
import { EmailAddressComponent } from './components/sw-questions/EmailAddress/email-address.component';
import { InsuranceCompanyComponent } from './components/sw-questions/InsuranceCompany/insurance-company.component';
import { PolicyHolderInfoComponent } from './components/sw-questions/PolicyHolder/policy-holder-info.component';
import { PolicyStartRealDateComponent } from './components/sw-questions/PolicyStartRealDate/policy-start-real-date.component';
import { OtherPolicyHolderComponent } from './components/sw-questions/OtherPolicyHolder/other-policy-holder.component';
import { PostalCodeComponent } from './components/sw-questions/PostalCode/postal-code.component';
import { PhoneComponent } from './components/sw-questions/Phone/phone.component';

export const routes: Routes = [
  {
    path: '',
    component: SwWrapperComponent,
    children: [
      { path: 'Q1', component: InsuranceCompanyComponent },
      { path: 'Q2', component: PolicyStartRealDateComponent },
      { path: 'Q3', component: PolicyHolderInfoComponent },
      { path: 'Q4', component: OtherPolicyHolderComponent },
      { path: 'Q5', component: PostalCodeComponent },
      { path: 'Q6', component: PhoneComponent },
      { path: 'Q7', component: EmailAddressComponent }
      // { path: 'Q8', component: PolicyHolderInfoComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SectionWiseRoutingModule {}
